// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottom":"bottom-1rZSOpMa"};